import React, { Component } from "react";
import {
  Button,
  Checkbox,
  Col,
  message,
  Form,
  Input,
  Row,
  Select,
  Upload,
  TimePicker,
  Modal,
  Spin,
  Card,
  Typography,
  notification,
  Avatar
} from "antd";

import { PhoneOutlined, CarOutlined, CloseOutlined, UploadOutlined } from "@ant-design/icons";

import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";

import PassengersStore from "../store/PassengerStore";
import withRouter1 from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";
import CountryStore from "../store/CountryStore";

import CompanyStore from "../store/CompanyStore";

import BookingStore from "../store/BookingStore";

import { times } from "lodash";
import Autocomplete from "react-google-autocomplete";
import config from "../config";
import conf from "../config";
import ListTable from "./ListTable";

import "leaflet/dist/leaflet.css";
import BookingMap from "./BookingMap";
import dayjs from "dayjs";
import { da } from "date-fns/locale";

const { Option } = Select;
const { Title, Text } = Typography;

class BookingAdd extends Component {
  formRef = React.createRef();
  constructor(prop) {
    super(prop);
    this.state = {
      loading: false,
      passengerId: -1,
      stId: -1,
      getVehicles: [],
      companyId: "",
      employeeType: false,
      studentType: true,
      type: "Student",

      busRootShow: false,

      currentPage: "",
      pageSize: "",
      addressMap: false,
      addressInfo: [],
      update: 0,
      photo: "",
      fileList: "",
      loadingSpin: false,

      mobileNo: "",
      pickupLatitude: "",
      pickupLongitude: "",
      dropLatitude: "",
      dropLongitude: "",
      customerId: "",
      taxiTypeId: "",
      pickupLocation: "",
      dropoffLocation: "",
      bookingTypeId: "",
      showBookingModal: false
    };
    this.passengerStore = new PassengersStore(this);
    this.vehicleStore = new VehicleStore(this);
    this.companyStore = new CompanyStore(this);
    this.bookingStore = new BookingStore(this);
    this.countryStore = new CountryStore(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    // this.handleOnkeyUp = this.handleOnkeyUp.bind(this);
  }
  async componentDidMount() {
    // await this.bookingStore.getFareDetails();
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setPassengerStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

    }
    const passengerId = this.props.passengerIdEdit;

    if (passengerId) {
      this.filldata(passengerId);
    }
    // this.passengerStore.getAddress()

    const data = await this.bookingStore.getVehicleType();
    await this.countryStore.getCountry();

    await this.setState({ loadList: 1 });
  }
  filldata = async (passengerId) => {
    await this.setState({ loadingSpin: true });
    const getPassengerData = await this.passengerStore.getPassenger(
      passengerId
    );

    await this.passengerStore.getBusNo(getPassengerData.companyId);
    await this.setState({
      companyId: getPassengerData.companyId,
      passengerId: getPassengerData.passengerId,
      stId: getPassengerData.stId,
    });
    const singleData = await this.companyStore.getCompanyDataById(
      getPassengerData.companyId
    );
    await this.passengerStore.getAllClass();
    await this.formRef.current.setFieldsValue({
      studentName: getPassengerData.studentName,

      passengerId: getPassengerData.passengerId,
      companyId: singleData,
      vehicleNo: getPassengerData.vehicleId,
      idNo: getPassengerData.idNo,
      mobileNo: getPassengerData.mobileNo,
      tagId: getPassengerData.tagId,
      employeeDepartment: getPassengerData.employeeDepartment,
      employeeDesignation: getPassengerData.employeeDesignation,
      employeeName: getPassengerData.employeeName,
      // classId: getPassengerData.className,
      className: getPassengerData.classId,
      schoolName: getPassengerData.schoolName,
      type: getPassengerData.type,

      term: getPassengerData.term,
      transportation: getPassengerData.transportation,
      vehicleType: getPassengerData.vehicleType,
      dropOffTime: getPassengerData.dropOffTime
        ? dayjs(getPassengerData.dropOffTime, "HH:mm")
        : "",
      pickUpTime: getPassengerData.pickUpTime
        ? dayjs(getPassengerData.pickUpTime, "HH:mm")
        : "",
      dropPoint: getPassengerData.dropPoint,
      pickUpPoint: getPassengerData.pickUpPoint,
      zone: getPassengerData.zone,
      // createDate:getPassengerData.createDate,
      bloodGroup: getPassengerData.bloodGroup,

      classDiv: getPassengerData.classDiv,
      guardianContactNo: getPassengerData.guardianContactNo,
      guardianName: getPassengerData.guardianName,
      motherContactNo: getPassengerData.motherContactNo,
      motherName: getPassengerData.motherName,
      fatherContactNo: getPassengerData.fatherContactNo,
      fatherName: getPassengerData.fatherName,
      transportationType: getPassengerData.transportationType,
      fee: getPassengerData.fee,

      siblingsClass1: getPassengerData.siblingsClass1,
      siblingsId1: getPassengerData.siblingsId1,
      siblingsName1: getPassengerData.siblingsName1,
      // photo: getPassengerData.photo,
      status: getPassengerData.status,
      longitude: getPassengerData.longitude,
      latitude: getPassengerData.latitude,
      mobileapp: getPassengerData.mobileapp,

      siblingsName2: getPassengerData.siblingsName2,
      siblingsId2: getPassengerData.siblingsId2,
      siblingsClass2: getPassengerData.siblingsClass2,

      stId: getPassengerData.stId,
      countryCode: getPassengerData.countryCode,
      fatherContactNoCountryCode: getPassengerData.fatherContactNoCountryCode,
      motherContactNoCountryCode: getPassengerData.motherContactNoCountryCode,
      guardianContactNoCountryCode:
        getPassengerData.guardianContactNoCountryCode,
    });
    this.setState({ photo: getPassengerData.photo });
    if (getPassengerData.type === "Student") {
      this.setState({ studentType: true });
      this.setState({ employeeType: false });
    } else if (getPassengerData.type === "Employee") {
      this.setState({ employeeType: true });
      this.setState({ studentType: false });
    }

    await this.setState({ loadingSpin: false });
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.addressMap &&
      prevState.addressMap !== this.state.addressMap
    ) {
      console.log("ilocasd");
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }
  }

  callCheckStatus = async (data) => {
    this.setState({ loadingSpin: true });
    const statusData = await this.bookingStore.getBookingStatus(data);
    if (statusData.bookingRequestStatus == 1) {
      setTimeout(() => {
        this.callCheckStatus(data);
      }, 10000); // 5 seconds
    } else if (statusData.bookingRequestStatus == 2) {

      this.setState({ loadingSpin: false, showBookingModal: true, bookingData: statusData });
      // await this.confirmBooking(3);
      // this.threeMinCancelTimeOut = setTimeout(function () {
      //   this.confirmBooking(3);
      // }, 180000);

    } else {
      //message.error(this.context.translate('_NO_TAXI_FOUND_'),0);
      notification.config({
        placement: "top", // or 'topLeft', 'bottomRight', 'bottomLeft'
        top: 50, // optional: distance from top (in pixels)
      });

      notification.error({
        message: "Error",
        description: this.context.translate("_NO_TAXI_FOUND_"),
        duration: 0, // stays until closed
      });

      this.setState({ loadingSpin: false });
    }
  };

  searchCustomer = async (fieldsValue) => {
    const data = await this.bookingStore.searchCustomer({
      mobileNo: this.state.mobileNo,
      companyId: this.state.companyId,
    });
    console.log(data)
    if (!data) {
      await this.formRef.current.setFieldsValue({
        customerName: "",
        customerEmail: "",
      });

    } else {
      await this.formRef.current.setFieldsValue({
        customerName: data.name ? data.name : "",
        customerEmail: data.emailId ? data.emailId : "",
      });
    }

  };

  onPassengerDetailSubmit = async (fieldsValue) => {
    this.setState({ loading: true });
    console.log(fieldsValue);
    const data = {
      ...fieldsValue,

      pickupLatitude: this.state.pickupLocation?.lat,
      pickupLongitude: this.state.pickupLocation?.lng,
      customerContactNo: this.state.mobileNo,
      dropLatitude: this.state.dropoffLocation?.lat,
      dropLongitude: this.state.dropoffLocation?.lng,
      companyId: this.props.getUserData().userCompanyId,
      isadmin: this.props.getUserData().isadmin,
      customerId: this.state.customerId,
      radius: 10,
      driverResponseTime: 30,
      taxiSearchTime: 2,
      bookingDateTime: dayjs().format("YYYY-MM-DD 00:00:00"),
      advancedBookingDate: "",
      isAdvancedBooking: 0,

      noOfBags: "",
      speacialAssistance: "",
    };

    console.log(data, "data");

    const response = await this.bookingStore.bookingRequest(data);
    console.log(response);
    if (response) {//notificationId == -1
      data.customerId = this.state.customerId;
      data.bookingId = response.bookingId;
      data.notificationId = response.notificationId;
      // this.setState({ loadingSpin: true, showBookingModal: true, bookingData: data });
      this.callCheckStatus(data);
    }

    this.setState({ loading: false });
  };

  handleOnKeyUp = (event) => {
    const value = event.target.value;

    // You can save or update state here
    this.setState({ mobileNo: value });
  };

  closeModal = () => {
    this.props.closeModal();
  };

  handlePickupSelected = (place) => {
    this.setState({ addressMap: true });
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const location = { lat, lng };

    this.setState({ pickupLocation: location });

    this.formRef.current.setFieldsValue({
      pickupAddress: place.formatted_address,
    });
  };

  handleDropoffSelected = async (place) => {
    await this.setState({ addressMap: true });
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const location = { lat, lng };

    this.setState({ dropoffLocation: location }, () => {
      this.loadFareDetailsData();
    });

    this.formRef.current.setFieldsValue({
      dropAddress: place.formatted_address,
    });
  };

  loadFareDetailsData = async () => {
    const { pickupLocation, dropoffLocation, taxiTypeId, bookingTypeId } = this.state;

    if (bookingTypeId == 1 && (!pickupLocation || !dropoffLocation || !taxiTypeId)) {
      console.warn("Missing data for fare calculation.");
      return;
    }
    // {"pickupLatitude":null,"pickupLongitude":null,"dropLatitude":null,"dropLongitude":null,"companyId":"1","duration":0,"bookingDateTime":"2025-07-28 19:16:06","taxiTypeId":1}
    await this.bookingStore.getFareDetails({
      pickupLatitude: pickupLocation.lat,
      pickupLongitude: pickupLocation.lng,
      dropLatitude: dropoffLocation.lat,
      dropLongitude: dropoffLocation.lng,
      companyId: this.props.getUserData().userCompanyId,
      duration: 0,
      bookingDateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      taxiTypeId: this.state.taxiTypeId,
      bookingTypeId: this.state.bookingTypeId,
    });
  };
  showTabDesc = () => {
    const { activeTab } = this.state;
    if (activeTab === "1") {
      return this.context.translate("_ACCOUNT_ADD_DESC_");
    } else if (activeTab === "2") {
      return this.context.translate("_USER_ADD_DESC_");
    } else if (activeTab === "3") {
      return this.context.translate("_PAYMENT_TAB_DESC_");
    }
  };
  handleCancel = () => {
    this.props.closeModal();
  };
  async confirmBooking(status) {
    const postData = {};
    postData.bookingId = this.state.bookingData?.bookingId;
    postData.notificationId = this.state.bookingData?.notificationId;
    postData.status = status;
    let bookingStatus = '';
    if (status == 1) {
      // this.BookingWindow.setLoading('Confirming Booking..');
      bookingStatus = 'Booking Confirmed';
    } else if (status == 3) {

      bookingStatus = 'Booking Canecled';
    }
    const resp = await this.bookingStore.confirmBooking(postData);
    this.setState({ showBookingModal: false, bookingData: null });
    this.formRef.current.resetFields();
    this.closeModal();
    // if (resp?.success == 'S') {
    //   this.setState({ showBookingModal: false, bookingData: null });
    // }else{

    // }



  }
  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              ref={this.formRef}
              layout="vertical"
              name="nest-messages"
              labelCol={{
                span: 20,
              }}
              colon={true}
              onFinish={this.onPassengerDetailSubmit}
              style={{ maxWidth: "100%", padding: 0 }}
              className="formClass"
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  <Row>
                    <Col span={15}>
                      <Form.Item
                        name="mobileNo"
                        // label="Id No"
                        label={this.context.translate(
                          "_FLEET_USER_USERLIST_MOBILENO_"
                        )}
                        rules={[
                          {
                            pattern: /^(\d{8}|\d{9}|\d{10})$/,
                            // message: "Enter a 7 or 10 digit number",
                            message: this.context.translate(
                              "_Enter_7_or_10_Digit_Number_"
                            ),
                          },
                        ]}
                      >
                        <Input onKeyUp={this.handleOnKeyUp} />
                      </Form.Item>
                    </Col>
                    <Col span={2} />
                    <Col span={7}>
                      <Form.Item label=" ">
                        <Button
                          type="primary"
                          onClick={() => this.searchCustomer()}
                        >
                          {/* Check Bus Route */}
                          {this.context.translate("_SEARCH_")}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>


                  <Form.Item
                    name="bookingTypeId"
                    label={
                      <span>
                        {this.context.translate("_BOOKING_TYPE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_BOOKING_TYPE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      onSelect={async (val) => {
                        await this.setState({ bookingTypeId: val });
                        if (val == 2) {
                          await this.loadFareDetailsData();
                          await this.setState({ loadList: 1 });
                        }
                      }}
                    >
                      <Option value={1}>Normal</Option>
                      <Option value={2}>Full Day</Option>
                    </Select>
                  </Form.Item>


                  <Form.Item
                    name="taxiTypeId"
                    // label={this.context.translate("_VEHICLE_TYPE_")}
                    // rules={[{ required: true }]}
                    label={
                      <span>
                        {this.context.translate("_VEHICLE_TYPE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_VEHICLE_TYPE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      onSelect={async (val) => {
                        await this.setState({ taxiTypeId: val });
                        await this.loadFareDetailsData();
                        await this.setState({ loadList: 1 });
                      }}
                    >
                      {this.bookingStore?.vehicleTypes.map((val) => {
                        return (
                          <Option
                            key={val.vehicleTypeId}
                            value={val.vehicleTypeId}
                          >
                            {val.vehicleTaxiType}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="pickupAddress"
                    // label="Location"
                    // label={this.context.translate("_PICKUP_ADDRESS_")}
                    label={
                      <span>
                        {this.context.translate("_PICKUP_ADDRESS_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_PICKUP_ADDRESS_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Autocomplete
                      style={{
                        width: "100%",
                        height: "46px",
                        boxShadow: "none",
                        padding: "4px 11px",
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: "#d9d9d9",
                        borderRadius: "5px",
                      }}
                      //  componentRestrictions={{ country: "us" }}
                      options={{
                        types: ["geocode", "establishment"],
                      }}
                      onLoad={(ref) => (this.pickup = ref)}
                      onPlaceSelected={this.handlePickupSelected}
                      placeholder={this.context.translate("_ENTER_LOCATION_")}
                      apiKey={config.googleMapKey}
                      componentRestrictions={{ country: "us" }}

                    />
                  </Form.Item>

                  {this.state.bookingTypeId == 2 ? (
                    <div style={{ marginTop: "20px", width: "100%" }}>
                      <h6>Full Day Fare Details</h6>
                      <table>
                        <tbody>
                          <tr>
                            <td>Full Day Min Charge</td>
                            <td>
                              <strong>
                                {this.bookingStore?.fareDetails?.fullDayMinCharges ||
                                  "--"}
                              </strong>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>) : (<div style={{ marginTop: "20px", width: "100%" }}>
                      <h6>Fare Details</h6>
                      <table>
                        <tbody>
                          <tr>
                            <td>Basic Fare:</td>
                            <td>
                              <strong>
                                {this.bookingStore?.fareDetails?.basicFare ||
                                  "--"}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Distance Fare(
                              {this.bookingStore?.fareDetails?.distance || 0}
                              Km):
                            </td>
                            <td>
                              <strong>
                                {this.bookingStore?.fareDetails?.distanceFare ||
                                  "--"}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Time Fare(
                              {this.bookingStore?.fareDetails?.duration || 0}
                              ):
                            </td>
                            <td>
                              <strong>
                                {this.bookingStore?.fareDetails?.timeFare || "--"}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Discount:</td>
                            <td>
                              <strong>
                                {this.bookingStore?.fareDetails?.discount || "--"}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>)}
                </Col>
                <Col span={12} className="formColumnClass">
                  <Form.Item
                    name="customerName"
                    // label="Blood Group"
                    // label={this.context.translate("_CUSTOMER_NAME_")}
                    label={
                      <span>
                        {this.context.translate("_CUSTOMER_NAME_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_CUSTOMER_NAME_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                    required={false}
                  // rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="customerEmail"
                    // label="Student Name"
                    label={this.context.translate("_MAILID_")}
                  // rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="noOfPassenger"
                    // label="Student Name"
                    label={this.context.translate("_NO_OF_PASSENGERS_")}
                  // rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>

                  <div
                    style={{ display: this.state.studentType ? "" : "none" }}
                  >
                    <Form.Item
                      name="Nationality"
                      label={this.context.translate("_NATIONALITY_")}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Select Nationality"
                        onSelect={(val) => this.setState({ Nationality: val })}
                        filterOption={(input, option) =>
                          (option?.children ?? "")
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {this.countryStore?.country.map((val) => (
                          <Option key={val.countryId} value={val.countryId}>
                            {val.country}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>                    <Form.Item
                      name="dropAddress"
                      // label="Location"
                      // label={this.context.translate("_DROPOFF_ADDRESS_")}
                      // rules={[{ required: true }]}
                      label={
                        <span>
                          {this.context.translate("_DROPOFF_ADDRESS_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_DROPOFF_ADDRESS_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                      required={false}
                    >
                      <Autocomplete
                        style={{
                          width: "100%",
                          height: "46px",
                          boxShadow: "none",
                          padding: "4px 11px",
                          borderWidth: 1,
                          borderStyle: "solid",
                          borderColor: "#d9d9d9",
                          borderRadius: "5px",
                        }}
                        componentRestrictions={{ country: "us" }}
                        options={{
                          types: ["geocode", "establishment"],
                        }}
                        placeholder={this.context.translate("_ENTER_LOCATION_")}
                        apiKey={config.googleMapKey}

                        onPlaceSelected={this.handleDropoffSelected}
                      />
                    </Form.Item>
                  </div>

                  <div
                    style={{
                      backgroundColor: "#f8f8f8",
                      border: "1px dashed #ccc",
                      padding: 20,
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: 20,
                    }}
                  >
                    <h6>Estimated Fare</h6>
                    <p
                      style={{
                        color: "crimson",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {this.bookingStore?.fareDetails?.fare || "--"}
                    </p>
                  </div>
                </Col>

              </Row>

              {/* <div className="formBtnGroup">
                <Button
                  className="formCancelButton"
                  onClick={(e) => {
                    this.closeModal();
                    // this.formRef.current?.resetFields();
                  }}
                >
                  {this.context.translate("_FLEET_CLOSE_BTN_")}
                </Button>
                <Button
                  type="primary"
                  className="formSaveButton"
                  htmlType="submit"
                  loading={this.state.loading}
                >
                  {this.context.translate("_RIDE_NOW_")}
                </Button>
              </div> */}

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => this.closeModal()}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  htmlType="submit"
                  className="formsSaveButton"
                >
                  {this.context.translate("_RIDE_NOW_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>
        <Modal
          className="multiTracking-popup"
          title={
            <div>
              Location On Map
              <CloseOutlined
                onClick={() => this.setState({ addressMap: false })}
              />
            </div>
          }
          maskClosable={false}
          style={{ padding: "0px !important" }}
          centered
          width={1000}
          open={this.state.addressMap}
          onCancel={() => this.setState({ addressMap: false })}
          footer={null}
        >
          <BookingMap
            origin={this.state.pickupLocation}
            destination={this.state.dropoffLocation}

          />
        </Modal>

        <Modal
          open={this.state.showBookingModal}
          onCancel={this.handleCancel}
          footer={null}
          closable={false}
          centered
          width={400}
          className="bcm-modal"
        >
          <div className="bcm-hero">
            <div className="bcm-hero-pattern" />
            <button className="bcm-close" onClick={this.handleCancel} aria-label="Close">
              <CloseOutlined />
            </button>
            <span className="bcm-status">Driver Assigned</span>
            <Avatar
              size={88}
              src={this.state.bookingData?.taxiDetails?.photo}
              className="bcm-avatar"
            >
              {this.state.bookingData?.taxiDetails?.name?.[0]}
            </Avatar>
          </div>

          <div className="bcm-body">
            <h3 className="bcm-name">{this.state.bookingData?.taxiDetails?.name}</h3>
            <p className="bcm-sub">Your ride is confirmed and on the way</p>

            <div className="bcm-info-grid">
              <div className="bcm-info-item">
                <span className="bcm-icon"><PhoneOutlined /></span>
                <div className="bcm-info-text">
                  <span className="bcm-label">Contact</span>
                  <span className="bcm-value">
                    {this.state.bookingData?.taxiDetails?.mobileno}
                  </span>
                </div>
              </div>

              <div className="bcm-info-item">
                <span className="bcm-icon"><CarOutlined /></span>
                <div className="bcm-info-text">
                  <span className="bcm-label">Taxi No</span>
                  <span className="bcm-value bcm-plate">
                    {this.state.bookingData?.taxiDetails?.vehicleNo}
                  </span>
                </div>
              </div>
            </div>

            <div className="bcm-fare-row">
              <span>Estimated Fare</span>
              <span className="bcm-fare">
                AED {this.bookingStore?.fareDetails?.fare || "--"}
              </span>
            </div>

            <div className="bcm-actions">
              <Button
                block
                className="bcm-btn-cancel"
                onClick={() => this.confirmBooking(3)}
              >
                Cancel
              </Button>
              <Button
                block
                type="primary"
                className="bcm-btn-confirm"
                onClick={() => this.confirmBooking(6)}
              >
                Confirm Booking
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
BookingAdd.contextType = StoreContext;
export default observer(withRouter1(BookingAdd));
